import { defineStore } from 'pinia';
import { dubbingGetLanguages } from '@/request/multilingual';

export const useDictsStore = defineStore('dicts', {
  state: () => {
    // 尝试从本地存储加载dicts，如果没有则使用默认值
    const storedDicts = localStorage.getItem('dictsData');
    const initialDicts = storedDicts ? JSON.parse(storedDicts) : {}; // 添加非空检查
    return {
      dictKey: ['seamless', 'elevenlabs', 'ims'],
      dicts: initialDicts, // 现在state初始化时会尝试从本地加载数据
    };
  },
  getters: {},
  actions: {
    async getDictsFn() {
      this.dicts = {}; // 先清空dicts，准备更新数据
      try {
        // 使用Promise.allSettled来并发执行请求并处理每个请求的结果
        const requests = this.dictKey.map(async (key) => {
          const res = await dubbingGetLanguages(key);
          return { key, result: res };
        });
        const results = await Promise.allSettled(requests);
        // 遍历结果，根据每个请求的fulfilled/rejected状态处理
        results.forEach((result, index) => {
          if (result.status === 'fulfilled') {
            const { key, result: res } = result.value;
            if (res.data.code === 200) {
              this.dicts[key] = res.data.data.targetLangList;
            } else {
              console.warn(`Failed to fetch languages for ${key}: ${res.data.message}`);
            }
          } else {
            console.error(`Request failed for key ${this.dictKey[index]}:`, result.reason);
          }
        });
        // 存储本地
        this.saveDictsToLocal();
      } catch (error) {
        console.error('An unexpected error occurred while fetching dictionaries:', error);
        // 可能还需要触发全局错误处理机制或通知用户
      }
      console.log('this.dictsthis.dicts', this.dicts);
    },

    saveDictsToLocal() {
      localStorage.setItem('dictsData', JSON.stringify(this.dicts));
    },

    removeDictsToLocal() {
      localStorage.removeItem('dictsData');
    },
    // 新增方法：检查本地存储是否有字典数据
    hasLocalDicts() {
      const storedDicts = localStorage.getItem('dictsData');
      return storedDicts !== null;
    },
  },
});
